import React from 'react'
import { Button, Modal } from "antd";
import { FaCircle } from "react-icons/fa";

export default function ModalNextBill({ visible, handleClose, data, sbg }) {
    return (
        <Modal
            title={"Daftar Cicilan Berikutnya"}
            visible={visible}
            onCancel={handleClose}
            width={600}
            centered
            footer={[
                <Button
                    key="back"
                    onClick={handleClose}
                    className="btn-modal btn-default"
                    style={{ width: "15%" }}
                >
                    Kembali
                </Button>,
            ]}
        >
            <div className="py-2">
                <div className='d-flex justify-content-between my-3'>
                    <div>No. SBG :</div>
                    <div style={{ fontWeight: '700' }}>{sbg}</div>
                </div>
                {data && data.length > 0 ?
                    data.map((item, index) => {
                        if (item.isPeriodAfterToday) {
                            return (
                                <div key={index} className='d-flex justify-content-between my-2'>
                                    <div className='d-flex'>
                                        <FaCircle size={10} style={{ marginTop: 7 }} />
                                        <div>
                                            <div className='ml-2'>Cicilan Ke-{item.periodNumber}</div>
                                            <div className='ml-2' style={{ fontSize: 12 }}>Periode : {item.periode}</div>
                                        </div>
                                    </div>
                                    <div style={{ fontWeight: '700' }}>{item.totalBill}</div>
                                </div>
                            )
                        }
                    })
                    :
                    <div className='text-bold text-center'>Tidak Ada Cicilan Berikutya</div>
                }
            </div>
        </Modal>
    )
}
